import React from "react";
import Form from "./Form";
import bgImg from "../../../assets/home/hero_sec_img.png";
import feature1 from "../../../assets/home/feature-1.png";
import feature2 from "../../../assets/home/feature-2.png";
import feature3 from "../../../assets/home/feature-3.png";
import icon1 from "../../../assets/home/icon1.png";
import icon2 from "../../../assets/home/icon2.png";
import icon3 from "../../../assets/home/icon3.png";
import icon4 from "../../../assets/home/icon4.png";
import icon5 from "../../../assets/home/icon5.png";
import icon6 from "../../../assets/home/icon6.png";
import iconBg from "../../../assets/home/backgroundimg.png";

const featureData = [
  {
    title: "Need a Ride?",
    image: feature1,
    icon: icon1,
  },
  {
    title: "Confirm & Relax",
    image: feature2,
    icon: icon2,
  },
  {
    title: "Ride & Reach Safely",
    image: feature3,
    icon: icon3,
  },
];

const Main = ({ routePrefill }) => {
  return (
    <main className="home-main">
      <section className="home-hero-bg">
        <div className="home-hero-container">

          {/* Image + icons — icons anchor to image only */}
          <div className="home-hero-image">
            <img src={bgImg} alt="Cab booking" className="main-bg-img" />
            <div className="hero-icons-row">
              <div className="hero-icon-item">
                <img src={icon5} alt="Car" className="hero-mini-icon" />
                <span className="hero-icon-label">10K+</span>
                <span className="hero-icon-sublabel">RIDES</span>
              </div>
              <div className="hero-icon-item">
                <img src={icon4} alt="Location" className="hero-mini-icon" />
                <span className="hero-icon-label">450+</span>
                <span className="hero-icon-sublabel">CITIES</span>
              </div>
              <div className="hero-icon-item">
                <img src={icon6} alt="Star" className="hero-mini-icon" />
                <span className="hero-icon-label">4.9/5</span>
                <span className="hero-icon-sublabel">RATING</span>
              </div>
            </div>
          </div>

          {/* Form — order:-1 floats it above image on mobile */}
          <div className="home-hero-form-wrapper">
            <div className="home-hero-form">
              <Form routePrefill={routePrefill} />
            </div>
          </div>

        </div>
      </section>

      <section className="home-main__features-wrapper">
        <h2 className="features-main-heading">Simple. Easy. Reliable.</h2>
        <div className="home-main__features">
          {featureData.map((item, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-card__image-wrapper">
                <img src={item.image} alt={item.title} />
                <div className="feature-card__title">{item.title}</div>
                <div className="feature-card__icon-box">
                  <img src={iconBg} alt="icon bg" className="feature-card__icon-bg" />
                  <img src={item.icon} alt="icon" className="feature-card__icon" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Main;